import {
  ColumnDirective,
  ColumnsDirective,
  GridComponent,
  Inject,
  Page,
  Resize,
  Search,
  Sort,
  Toolbar,
} from "@syncfusion/ej2-react-grids";
import axios from "axios";
import { getCookie } from "cookies-next";
import { useEffect, useRef, useState } from "react";
import { FaCheckCircle, FaPlus, FaRegCopy, FaRegEdit } from "react-icons/fa";
import { FaRegistered, FaXmark } from "react-icons/fa6";
import { IoMdArrowBack } from "react-icons/io";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";

import { DropDownListComponent } from "@syncfusion/ej2-react-dropdowns";
import React from "react";
import { DeleteValidation, PageLoading } from "../../../components";
import { API_ROOT } from "../../../config";
import { useStateContext } from "../../../contexts/ContextProvider";
import BlankProfile from "../../../data/blank.png";
import "../../table.css";
import "./integratedPlatform.css";

const Details = () => {
  const { uuid } = useParams();
  const navigate = useNavigate();
  const { currentColor } = useStateContext();

  const [pageLoading, setPageLoading] = useState(true);
  const [paymentMethod, setPaymentMethod] = useState([]);
  const [detailData, setDetailData] = useState(null);
  const [memberData, setMemberData] = useState(null);
  const [deleteValidation, setDeleteValidation] = useState(false);
  const [deleteLoading, setDeleteLoading] = useState(false);
  const [activateLoading, setActivateLoading] = useState(false);
  const gridRef = useRef(null);

  const [toggleEdit, setToggleEdit] = useState(false);
  const [editLoading, setEditLoading] = useState(false);
  const [editPlatformData, setEditPlatformData] = useState(null);
  const [editPlatformWarning, setEditPlatformWarning] = useState(null);
  const editPlatformPattern = {
    customer_key: /^[a-zA-Z0-9_]+$/,
  };

  const [toggleAddMember, setToggleAddMember] = useState(false);
  const [addMemberData, setAddMemberData] = useState(null);
  const [addMemberLoading, setAddMemberLoading] = useState(false);
  const [addMemberWarning, setAddMemberWarning] = useState(null);

  const [editMember, setEditMember] = useState(null);
  const [editMemberLoading, setEditMemberLoading] = useState(false);
  const [deleteMemberValidation, setDeleteMemberValidation] = useState(false);

  // LOADING
  const [registerLoading, setRegisterLoading] = useState(false);
  const [sendEkycLoading, setSendEkycLoading] = useState(false);
  const [signupPdsLoading, setSignupPdsLoading] = useState(false);
  const [certificateCheckLoading, setCertificateCheckLoading] = useState(false);
  const [isLoadingGetApiKey, setIsLoadingGetApiKey] = useState(false);

  // MASTER DATA
  const [sumberPlatforms, setSumberPlatforms] = useState([]);

  const PERSONEL = "PERSONAL";
  const COMPANY = "COMPANY";

  const fetchPaymentMethodMasterdata = async () => {
    await axios
      .get(API_ROOT + "/admin/masterdata-management/payment-methods", {
        headers: {
          Authorization: getCookie("admin_auth"),
        },
      })
      .then((response) => {
        const mainData = response.data.data;

        setPaymentMethod(mainData);
      })
      .catch((error) => {
        toast.error("Failed to fetch data");

        if (error.response) {
          if (error.response.status == 401) {
            navigate("/login");
          }
        }
      });
  };

  const fetchSumberPlatforms = async () => {
    try {
      const response = await axios.get(
        API_ROOT + "/admin/select/sumber-platforms",
        {
          headers: { Authorization: getCookie("admin_auth") },
        },
      );

      setSumberPlatforms(
        response.data.data.map((item) => ({
          text: item.nama_platform,
          value: item.id,
        })),
      );
    } catch (error) {
      if (error.response?.status === 401) {
        navigate("/login");
      }
    }
  };

  const fetchDetails = async (uuid) => {
    await axios
      .get(API_ROOT + "/admin/user/integrated-platform/details/" + uuid, {
        headers: {
          Authorization: getCookie("admin_auth"),
        },
      })
      .then((response) => {
        const mainData = response.data.data;

        setDetailData(mainData);

        setMemberData(() =>
          mainData.integrated_members.map((item, index) => {
            return {
              No: index + 1,
              Uuid: item.user.uuid,
              Name: item.user.name,
              Username: item.user.username,
              Email: item.user.email,
              PhoneNumber: item.user.phone_number,
              IsActive: item.is_member,
              IsActiveText: item.is_member ? "Active" : "Inactive",
              PaymentMethod: item.payment_method.payment_method_name,
              PaymentMethodKey: item.payment_method.key_payment_method,
              IsRegisterMarkany: item.user.is_register_markany,
              Role: item.user?.role?.key_role,
              Ekyc: item.user?.user_detail?.ekyc,
              IsMarkanyUser: item.user?.user_detail?.is_markany,
              StatusMarkany: item.user?.user_detail?.status_markany,
              LinkOnboardingExpired:
                item.user?.user_detail?.link_onboarding_expired,
              RegistrationLink: item.user?.user_detail?.registration_link,
              StatusCertificateCa:
                item.user?.user_detail?.status_certificate_ca?.name,
            };
          }),
        );

        window.scrollTo({ top: 0, left: 0 });
      })
      .catch((error) => {
        toast.error("Failed to open data");

        if (error.response) {
          if (error.response.status == 401) {
            navigate("/login");
          }
        }
      })
      .finally(() => setPageLoading(false));
  };

  const getApiKey = async () => {
    setIsLoadingGetApiKey(true);
    await axios
      .get(
        API_ROOT + "/admin/user/integrated-platform/manage/api-key/" + uuid,
        {
          headers: {
            Authorization: getCookie("admin_auth"),
          },
        },
      )
      .then((response) => {
        const data = response.data?.data;

        toast.success(data?.message || "API key generated");
        setEditPlatformData((prev) => ({
          ...prev,
          api_key: data?.access_token,
        }));
        // setDetailData((prev) => ({
        //   ...prev,
        //   api_key: data?.access_token,
        // }));

        window.scrollTo({ top: 0, left: 0 });
      })
      .catch((error) => {
        toast.error("Failed to generate api key");

        if (error.response) {
          if (error.response.status == 401) {
            navigate("/login");
          }
        }
      })
      .finally(() => setIsLoadingGetApiKey(false));
  };

  useEffect(() => {
    fetchPaymentMethodMasterdata();
    fetchDetails(uuid);
    fetchSumberPlatforms();
  }, [uuid]);

  useEffect(() => {
    async function searchUser(value) {
      if (value) {
        await axios
          .get(API_ROOT + "/admin/user/search?keywords=" + value, {
            headers: {
              Authorization: getCookie("admin_auth"),
            },
          })
          .then((response) => {
            const userList = response.data.data;

            setEditPlatformData((prev) => ({ ...prev, owner_list: userList }));
          })
          .catch((error) => {
            if (error.response) {
              if (error.response.status == 401) {
                navigate("/login");

                return;
              }
            }
            setEditPlatformData((prev) => ({ ...prev, owner_list: [] }));
            toast.error("Failed to get data");
          });
      } else {
        setEditPlatformData((prev) => ({ ...prev, owner_list: [] }));
      }
    }

    const timeout = setTimeout(() => {
      if (editPlatformData) {
        searchUser(editPlatformData.owner_temp);
      }
    }, 500);

    return () => {
      clearTimeout(timeout);
    };
  }, [editPlatformData && editPlatformData.owner_temp]);

  useEffect(() => {
    async function searchUser(value) {
      if (value) {
        await axios
          .get(API_ROOT + "/admin/user/search?keywords=" + value, {
            headers: {
              Authorization: getCookie("admin_auth"),
            },
          })
          .then((response) => {
            const userList = response.data.data;

            setAddMemberData((prev) => ({ ...prev, member_list: userList }));
          })
          .catch((error) => {
            if (error.response) {
              if (error.response.status == 401) {
                navigate("/login");

                return;
              }
            }
            setAddMemberData((prev) => ({ ...prev, member_list: [] }));
            toast.error("Failed to get data");
          });
      } else {
        setAddMemberData((prev) => ({ ...prev, member_list: [] }));
      }
    }

    const timeout = setTimeout(() => {
      if (addMemberData) {
        searchUser(addMemberData.member_temp);
      }
    }, 500);

    return () => {
      clearTimeout(timeout);
    };
  }, [addMemberData && addMemberData.member_temp]);

  const actionTemplate = (props) => {
    return (
      <div className="e-actionParent gap-2">
        <button
          className="e-action"
          onClick={() => {
            window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
            setEditMember(props);
          }}
        >
          <FaRegEdit className="e-actionIcon" />
          <div>Edit</div>
        </button>
        {props.Role && props.Role === PERSONEL && props.IsMarkanyUser && (
          <React.Fragment>
            {props.StatusMarkany === "generate-link" && (
              <button
                className="flex items-center gap-2 py-2 px-3 border border-[#3b82f6] rounded-md text-[#3b82f6]"
                onClick={() => handleOnBoardingGenerateLink(props.Uuid)}
              >
                <FaRegistered className="text-lg" />
                <div>Generate Link</div>
              </button>
            )}

            {props.RegistrationLink &&
              props.StatusMarkany === "onboarding-peruri" && (
                <button
                  className="flex items-center gap-2 py-2 px-3 border border-indigo-500 rounded-md text-indigo-500"
                  onClick={() =>
                    handleCopyRegistrationLink(props.RegistrationLink)
                  }
                >
                  <FaRegCopy className="text-lg" />
                  <div>Copy Registration Link</div>
                </button>
              )}

            {(props.StatusMarkany === "menunggu-verification-peruri" ||
              props.StatusMarkany === "completed") && (
              <button
                className="flex items-center gap-2 py-2 px-3 border border-[#3b82f6] rounded-md text-[#3b82f6]"
                onClick={() => handleCertificateCheck(props.Uuid)}
              >
                <FaCheckCircle className="text-lg" />
                <div>Certificate Check</div>
              </button>
            )}
          </React.Fragment>
        )}
      </div>
    );
  };

  const handleRegisterMarkany = async (userUuid) => {
    setRegisterLoading(true);
    try {
      await axios.put(
        API_ROOT + "/admin/user/register-markany/" + userUuid,
        {},
        {
          headers: {
            Authorization: getCookie("admin_auth"),
          },
        },
      );
      toast.success("User Updated!");

      fetchDetails(uuid);
    } catch (error) {
      toast.error(
        error.response?.data?.message ?? "Failed to Register user to markany!",
      );

      if (error.response) {
        if (error.response.status === 401) {
          navigate("/login");
        }
      }
    }

    setRegisterLoading(false);
  };

  const handleOnBoardingGenerateLink = async (userUuid) => {
    setRegisterLoading(true);
    try {
      await axios.put(
        API_ROOT + "/admin/user/onboarding-generate-link/" + userUuid,
        {},
        {
          headers: {
            Authorization: getCookie("admin_auth"),
          },
        },
      );
      toast.success("User Updated!");

      fetchDetails(uuid);
    } catch (error) {
      toast.error(
        error.response?.data?.message ?? "Failed to Register user to markany!",
      );

      if (error.response) {
        if (error.response.status === 401) {
          navigate("/login");
        }
      }
    }

    setRegisterLoading(false);
  };

  const handleCertificateCheck = async (userUuid) => {
    setCertificateCheckLoading(true);
    try {
      const response = await axios.get(
        API_ROOT + "/admin/user/certificate-check/" + userUuid,
        {
          headers: {
            Authorization: getCookie("admin_auth"),
          },
        },
      );
      toast.success(response.data?.message || "Certificate Check Success");

      fetchDetails(uuid);
    } catch (error) {
      toast.error(
        error.response?.data?.message ??
          "Failed to certificate check to markany!",
      );

      if (error.response) {
        if (error.response.status === 401) {
          navigate("/login");
        }
      }
    }

    setCertificateCheckLoading(false);
  };

  const handleCopyRegistrationLink = async (link) => {
    try {
      await navigator.clipboard.writeText(link);
      toast.success("Registration link copied!");
    } catch (error) {
      toast.error("Failed to copy link");
    }
  };

  const queryCellInfo = (args) => {
    args.cell?.classList.add("e-cell");
  };

  const dataBound = () => {
    if (gridRef.current) {
      gridRef.current.autoFitColumns();
    }
  };

  const getBadgeStatusMarkany = (status) => {
    switch (status) {
      case "register-account":
        return {
          label: "Register Account",
          class: "bg-blue-100 text-blue-800",
        };

      case "generate-link":
        return {
          label: "Generate Link",
          class: "bg-orange-100 text-orange-800",
        };

      case "onboarding-peruri":
        return {
          label: "Onboarding Peruri",
          class: "bg-purple-100 text-purple-800",
        };

      case "menunggu-verification-peruri":
        return {
          label: "Menunggu Verifikasi Peruri",
          class: "bg-yellow-100 text-yellow-800",
        };

      case "completed":
        return {
          label: "Completed",
          class: "bg-green-100 text-green-800",
        };

      default:
        return {
          label: status,
          class: "bg-gray-100 text-gray-800",
        };
    }
  };

  const getBadgeStatusCertificate = (status) => {
    switch (status) {
      case "active":
        return { label: "Active", class: "bg-green-100 text-green-800" };
      case "expiring_soon":
        return {
          label: "Expiring Soon",
          class: "bg-yellow-100 text-yellow-800",
        };
      case "expired":
        return { label: "Expired", class: "bg-red-100 text-red-800" };
      default:
        return { label: status || "-", class: "bg-gray-100 text-gray-800" };
    }
  };

  return pageLoading ? (
    <PageLoading />
  ) : (
    <div className="flex flex-col gap-4 m-2 md:m-10 mt-24 px-2 py-10 md:p-10 bg-white rounded-3xl">
      <div className="flex justify-between items-center">
        <div className="flex items-center gap-4">
          <button onClick={() => navigate("/user/integrated-platform")}>
            <IoMdArrowBack className="w-6 h-6" />
          </button>
          <h1 className="text-xl font-medium">Platform Details</h1>
        </div>
        <button
          style={{ backgroundColor: currentColor }}
          className="text-white w-36 py-2 px-4 rounded-md text-sm"
          onClick={() => {
            setEditPlatformData({
              platform_name: detailData.platform_name,
              customer_key: detailData.customer_key,
              sumber_platform_id: detailData.sumber_platform_id,
              api_key: detailData.api_key,
              issuerId: detailData.issuerId,
              selected_owner: {
                uuid: detailData.owner.uuid,
                name: detailData.owner.name,
                username: detailData.owner.username,
                image: detailData.owner.image,
              },
              owner_temp: null,
              owner_list: [],
            });
            setEditPlatformWarning({
              platform_name: null,
              customer_key: null,
              sumber_platform_id: null,
              api_key: null,
              issuerId: null,
              selected_owner: null,
            });
            setToggleEdit(true);
          }}
        >
          Edit Platform
        </button>
      </div>
      <hr />
      <div className="flex flex-col gap-1">
        <div className="flex">
          <div className="flex-none w-40 bg-gray-600 text-white pl-2 py-1 flex items-center">
            Platform Name
          </div>
          <div className="flex-auto px-2 py-1 border border-gray-600 box-border break-all">
            {detailData.platform_name}
          </div>
        </div>
        <div className="flex">
          <div className="flex-none w-40 bg-gray-600 text-white pl-2 py-1 flex items-center">
            Sumber Platform
          </div>
          <div className="flex-auto px-2 py-1 border border-gray-600 box-border break-all">
            {detailData.sumber_platform?.nama_platform}
          </div>
        </div>
        <div className="flex">
          <div className="flex-none w-40 bg-gray-600 text-white pl-2 py-1 flex items-center">
            Customer Key
          </div>
          <div className="flex-auto px-2 py-1 border border-gray-600 box-border break-all">
            {detailData.customer_key}
          </div>
        </div>
        <div className="flex">
          <div className="flex-none w-40 bg-gray-600 text-white pl-2 py-1 flex items-center">
            API Key
          </div>
          <div className="flex-auto px-2 py-1 border border-gray-600 box-border break-all">
            {detailData.api_key}
          </div>
        </div>
        <div className="flex">
          <div className="flex-none w-40 bg-gray-600 text-white pl-2 py-1 flex items-center">
            Issuer ID
          </div>
          <div className="flex-auto px-2 py-1 border border-gray-600 box-border break-all">
            {detailData.issuerId}
          </div>
        </div>
        <div className="flex">
          <div className="flex-none w-40 bg-gray-600 text-white pl-2 py-1 flex items-center">
            Secret Key
          </div>
          <div className="flex-auto px-2 py-1 border border-gray-600 box-border break-all">
            {detailData.secret_key}
          </div>
        </div>
        <div className="flex">
          <div className="flex-none w-40 bg-gray-600 text-white pl-2 py-1 flex items-center">
            Is Active
          </div>
          <div className="flex-auto px-2 py-1 border border-gray-600 box-border break-all">
            {detailData.is_active ? "True" : "False"}
          </div>
        </div>
        <div className="flex">
          <div className="flex-none w-40 bg-gray-600 text-white pl-2 py-1 flex items-center">
            Owner Name
          </div>
          <div className="flex-auto px-2 py-1 border border-gray-600 box-border break-all">
            {detailData.owner.name}
          </div>
        </div>
        <div className="flex">
          <div className="flex-none w-40 bg-gray-600 text-white pl-2 py-1 flex items-center">
            Owner Username
          </div>
          <div className="flex-auto px-2 py-1 border border-gray-600 box-border break-all">
            {detailData.owner.username}
          </div>
        </div>
      </div>
      <div className="flex justify-end items-center gap-4 mt-4">
        <button
          disabled={activateLoading || deleteLoading}
          className={
            "text-white w-44 py-2 px-4 rounded-md text-sm " +
            (detailData.is_active
              ? "bg-amber-500 hover:bg-amber-600"
              : "bg-green-500 hover:bg-green-600")
          }
          onClick={async () => {
            setActivateLoading(true);

            await axios
              .put(
                API_ROOT +
                  "/admin/user/integrated-platform/manage/update/" +
                  detailData.uuid,
                {
                  platform_name: null,
                  sumber_platform_id: null,
                  customer_key: null,
                  api_key: null,
                  issuerId: null,
                  is_active: !detailData.is_active,
                  owner: null,
                  members: null,
                },
                {
                  headers: {
                    Authorization: getCookie("admin_auth"),
                  },
                },
              )
              .then(async () => {
                toast.success(
                  detailData.is_active
                    ? "Platform Deactivated!"
                    : "Platform Activated",
                  {
                    onOpen: () => fetchDetails(uuid),
                  },
                );
              })
              .catch((error) => {
                toast.error("Failed to update platform!");

                if (error.response) {
                  if (error.response.status == 401) {
                    navigate("/login");
                  }
                }
              });

            setActivateLoading(false);
          }}
        >
          {activateLoading || deleteLoading
            ? "Loading..."
            : detailData.is_active
              ? "Deactivate Platform"
              : "Activate Platform"}
        </button>
        <button
          disabled={deleteLoading || activateLoading}
          className="text-white w-40 py-2 px-4 rounded-md text-sm bg-red-500 hover:bg-red-600"
          onClick={() => setDeleteValidation(true)}
        >
          {deleteLoading || activateLoading ? "Loading..." : "Delete Platform"}
        </button>
        {deleteValidation && (
          <DeleteValidation
            title={
              <div className="text-center">
                <p>{detailData.platform_name}</p>
                <p>Are you sure want to delete platform?</p>
              </div>
            }
            falseHandler={() => setDeleteValidation(false)}
            trueHandler={async () => {
              setDeleteLoading(true);

              await axios
                .delete(
                  API_ROOT +
                    "/admin/user/integrated-platform/manage/delete/" +
                    detailData.uuid,
                  {
                    headers: {
                      Authorization: getCookie("admin_auth"),
                    },
                  },
                )
                .then(async () => {
                  toast.success("Platform Deleted!", {
                    autoClose: 500,
                    onClose: () => navigate("/user/integrated-platform"),
                  });
                })
                .catch((error) => {
                  toast.error("Failed to delete platfrom!");

                  if (error.response) {
                    if (error.response.status == 401) {
                      navigate("/login");
                    }
                  }
                });

              setDeleteLoading(false);
              setDeleteValidation(false);
            }}
          />
        )}
      </div>
      {toggleEdit && (
        <div className="overflow-auto absolute z-[999999999999] top-0 left-0 flex justify-center w-full min-h-screen h-full overflow-y-auto py-40 px-[100px] bg-slate-800/50">
          <div className="bg-white flex flex-col gap-2 w-full max-w-[464px] h-fit rounded-xl p-8">
            <div className="flex items-center justify-between">
              <h1 className="text-xl font-medium">Edit Platform</h1>
              <div
                className="cursor-pointer p-2"
                onClick={() => setToggleEdit(false)}
              >
                &times;
              </div>
            </div>
            <hr />
            <div className="flex flex-col gap-4 w-fit">
              <div className="flex flex-col gap-2">
                <h4 className="font-medium">Platform Name</h4>
                <input
                  type="text"
                  placeholder="Input platform name..."
                  maxLength={100}
                  spellCheck="false"
                  className={
                    "w-[400px] p-2 text-sm rounded-[4px] border focus:outline-2 " +
                    (!editPlatformWarning.platform_name
                      ? "border-slate-500 focus:outline-sky-500"
                      : "border-red-500 focus:outline-red-500")
                  }
                  value={editPlatformData.platform_name}
                  onChange={(e) => {
                    setEditPlatformData((prev) => ({
                      ...prev,
                      platform_name: e.target.value,
                    }));

                    if (e.target.value.length < 1) {
                      setEditPlatformWarning((prev) => ({
                        ...prev,
                        platform_name: "Minimum of 1 character is required",
                      }));
                    } else {
                      setEditPlatformWarning((prev) => ({
                        ...prev,
                        platform_name: null,
                      }));
                    }
                  }}
                />
                {editPlatformWarning.platform_name && (
                  <p className="text-xs text-red-500">
                    {editPlatformWarning.platform_name}
                  </p>
                )}
              </div>
              <div className="flex flex-col gap-2">
                <h4 className="font-medium">Sumber Platform</h4>
                <DropDownListComponent
                  allowFiltering
                  dataSource={sumberPlatforms}
                  fields={{ text: "text", value: "value" }}
                  placeholder="Select integrated platform"
                  value={editPlatformData.sumber_platform_id}
                  change={(e) => {
                    if (e.value) {
                      setEditPlatformData((prev) => ({
                        ...prev,
                        sumber_platform_id: e.value,
                      }));
                      setEditPlatformWarning((prev) => ({
                        ...prev,
                        sumber_platform_id: null,
                      }));
                    } else {
                      setEditPlatformWarning((prev) => ({
                        ...prev,
                        sumber_platform_id: "Sumber Platform Required",
                      }));
                    }
                  }}
                  cssClass={
                    editPlatformWarning.sumber_platform_id ? "e-error" : ""
                  }
                  width="400px"
                />
                {editPlatformWarning.sumber_platform_id && (
                  <p className="text-xs text-red-500">
                    {editPlatformWarning.sumber_platform_id}
                  </p>
                )}
              </div>
              <div className="flex flex-col gap-2">
                <h4 className="font-medium">Customer Key</h4>
                <input
                  type="text"
                  placeholder="Input customer key..."
                  maxLength={60}
                  spellCheck="false"
                  className={
                    "w-[400px] p-2 text-sm rounded-[4px] border focus:outline-2 " +
                    (!editPlatformWarning.customer_key
                      ? "border-slate-500 focus:outline-sky-500"
                      : "border-red-500 focus:outline-red-500")
                  }
                  value={editPlatformData.customer_key}
                  onChange={(e) => {
                    setEditPlatformData((prev) => ({
                      ...prev,
                      customer_key: e.target.value,
                    }));

                    if (e.target.value.length < 1) {
                      setEditPlatformWarning((prev) => ({
                        ...prev,
                        customer_key: "Minimum of 1 character is required",
                      }));
                    } else if (
                      !editPlatformPattern.customer_key.test(e.target.value)
                    ) {
                      setEditPlatformWarning((prev) => ({
                        ...prev,
                        customer_key:
                          "Input contain not allowed characters or combinations",
                      }));
                    } else {
                      setEditPlatformWarning((prev) => ({
                        ...prev,
                        customer_key: null,
                      }));
                    }
                  }}
                />
                {editPlatformWarning.customer_key && (
                  <p className="text-xs text-red-500">
                    {editPlatformWarning.customer_key}
                  </p>
                )}
              </div>
              <div className="flex flex-col gap-2">
                <div className="flex justify-between items-center">
                  <h4 className="font-medium">API Key</h4>
                  <button
                    type="button"
                    disabled={isLoadingGetApiKey}
                    className={`
                      px-2 py-1 text-xs rounded-md transition-all 
                      ${
                        isLoadingGetApiKey
                          ? "bg-gray-300 cursor-not-allowed opacity-60"
                          : "bg-purple-300 cursor-pointer hover:bg-purple-400"
                      }
                    `}
                    onClick={getApiKey}
                  >
                    {!isLoadingGetApiKey ? "Get API KEY" : "Loading..."}
                  </button>
                </div>
                <textarea
                  placeholder="Input api key..."
                  spellCheck="false"
                  className={
                    "w-[400px] p-2 text-sm rounded-[4px] border focus:outline-2 " +
                    (!editPlatformWarning.api_key
                      ? "border-slate-500 focus:outline-sky-500"
                      : "border-red-500 focus:outline-red-500")
                  }
                  value={editPlatformData.api_key}
                  onChange={(e) => {
                    setEditPlatformData((prev) => ({
                      ...prev,
                      api_key: e.target.value,
                    }));
                  }}
                />
                {editPlatformWarning.api_key && (
                  <p className="text-xs text-red-500">
                    {editPlatformWarning.api_key}
                  </p>
                )}
              </div>
              <div className="flex flex-col gap-2">
                <h4 className="font-medium">Issuer Id</h4>
                <textarea
                  placeholder="Input issuer id..."
                  spellCheck="false"
                  className={
                    "w-[400px] p-2 text-sm rounded-[4px] border focus:outline-2 " +
                    (!editPlatformWarning.issuerId
                      ? "border-slate-500 focus:outline-sky-500"
                      : "border-red-500 focus:outline-red-500")
                  }
                  value={editPlatformData.issuerId}
                  onChange={(e) => {
                    setEditPlatformData((prev) => ({
                      ...prev,
                      issuerId: e.target.value,
                    }));
                  }}
                />
                {editPlatformWarning.issuerId && (
                  <p className="text-xs text-red-500">
                    {editPlatformWarning.issuerId}
                  </p>
                )}
              </div>
              <div className="flex flex-col gap-2">
                <h4 className="font-medium">Owner</h4>
                {editPlatformData.selected_owner ? (
                  <div className="flex justify-between items-center bg-white py-3 px-4 border border-slate-500 rounded-md">
                    <div className="flex gap-2 items-center">
                      <div>
                        <img
                          src={
                            editPlatformData.selected_owner.image
                              ? "data:image/*;base64," +
                                editPlatformData.selected_owner.image
                              : BlankProfile
                          }
                          alt="User profile image"
                          className="w-10 h-10 rounded-full object-cover"
                        />
                      </div>
                      <div className="fles flex-col justify-center text-sm">
                        <h1>{editPlatformData.selected_owner.name}</h1>
                        <h3 className="text-slate-700 font-semibold">
                          {"@" + editPlatformData.selected_owner.username}
                        </h3>
                      </div>
                    </div>
                    <button
                      className="p-2 cursor-pointer"
                      onClick={() => {
                        setEditPlatformData((prev) => ({
                          ...prev,
                          selected_owner: null,
                        }));
                      }}
                    >
                      <FaXmark className="w-3 h-3 text-slate-800" />
                    </button>
                  </div>
                ) : (
                  <>
                    <input
                      type="text"
                      placeholder="Search User"
                      spellCheck="false"
                      className={
                        "w-[400px] p-2 text-sm rounded-[4px] border focus:outline-2 " +
                        (!editPlatformWarning.selected_owner
                          ? "border-slate-500 focus:outline-sky-500"
                          : "border-red-500 focus:outline-red-500")
                      }
                      value={editPlatformData.owner_temp}
                      onChange={(e) => {
                        setEditPlatformData((prev) => ({
                          ...prev,
                          owner_temp: e.target.value,
                        }));
                        setEditPlatformWarning((prev) => ({
                          ...prev,
                          selected_owner: null,
                        }));
                      }}
                    />
                    {editPlatformData.owner_list.length !== 0 && (
                      <div className="flex flex-col w-[400px] max-h-[192px] border border-slate-500 overflow-y-auto rounded-md cursor-pointer">
                        {editPlatformData.owner_list.map((item, index) => (
                          <div
                            key={"owner" + index}
                            className="py-3 px-4 flex justify-between items-center bg-white hover:bg-slate-200 active:bg-slate-50"
                            onClick={() => {
                              setEditPlatformData((prev) => ({
                                ...prev,
                                selected_owner: item,
                                owner_temp: "",
                                owner_list: [],
                              }));
                              setEditPlatformWarning((prev) => ({
                                ...prev,
                                selected_owner: null,
                              }));
                            }}
                          >
                            <div className="flex gap-2 items-center">
                              <div>
                                <img
                                  src={
                                    item.image
                                      ? "data:image/*;base64," + item.image
                                      : BlankProfile
                                  }
                                  alt="User profile image"
                                  className="w-10 h-10 rounded-full object-cover"
                                />
                              </div>
                              <div className="fles flex-col justify-center text-sm">
                                <h1>{item.name}</h1>
                                <h3 className="text-slate-700 font-semibold">
                                  {"@" + item.username}
                                </h3>
                              </div>
                            </div>
                            <div>
                              <FaPlus className="w-3 h-3 text-slate-800" />
                            </div>
                          </div>
                        ))}
                      </div>
                    )}
                  </>
                )}
                {editPlatformWarning.selected_owner && (
                  <p className="text-xs text-red-500">
                    {editPlatformWarning.selected_owner}
                  </p>
                )}
              </div>
              <div className="flex justify-end items-center">
                <button
                  style={{ backgroundColor: currentColor }}
                  className="text-white w-36 mt-4 py-2 px-4 rounded-md text-sm"
                  onClick={async () => {
                    setEditLoading(true);

                    if (!editPlatformData.platform_name) {
                      setEditPlatformWarning((prev) => ({
                        ...prev,
                        platform_name: "Platform name can't be empty",
                      }));
                      setEditLoading(false);

                      return;
                    }

                    if (!editPlatformData.sumber_platform_id) {
                      setEditPlatformWarning((prev) => ({
                        ...prev,
                        sumber_platform_id: "Sumber Platform can't be empty",
                      }));
                      setEditLoading(false);

                      return;
                    }

                    if (!editPlatformData.customer_key) {
                      setEditPlatformWarning((prev) => ({
                        ...prev,
                        customer_key: "Customer key can't be empty",
                      }));
                      setEditLoading(false);

                      return;
                    }

                    if (!editPlatformData.selected_owner) {
                      setEditPlatformWarning((prev) => ({
                        ...prev,
                        selected_owner: "Owner can't be empty",
                      }));
                      setEditLoading(false);

                      return;
                    }

                    await axios
                      .put(
                        API_ROOT +
                          "/admin/user/integrated-platform/manage/update/" +
                          detailData.uuid,
                        {
                          platform_name: editPlatformData.platform_name,
                          customer_key: editPlatformData.customer_key,
                          sumber_platform_id:
                            editPlatformData.sumber_platform_id,
                          api_key: editPlatformData.api_key,
                          issuerId: editPlatformData.issuerId,
                          owner: editPlatformData.selected_owner.uuid,
                          is_active: null,
                          members: null,
                        },
                        {
                          headers: {
                            Authorization: getCookie("admin_auth"),
                          },
                        },
                      )
                      .then(async () => {
                        setToggleEdit(false);
                        toast.success("Platform Updated!", {
                          onOpen: () => fetchDetails(uuid),
                        });
                      })
                      .catch((error) => {
                        toast.error("Failed to update platform!");

                        if (error.response) {
                          if (error.response.status == 401) {
                            navigate("/login");
                          }
                        }
                      });

                    setEditLoading(false);
                  }}
                >
                  {!editLoading ? "Save" : "Loading..."}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
      <hr />
      <div className="flex items-center gap-6">
        <h1 className="text-xl font-medium">
          Members ({detailData.integrated_members.length})
        </h1>
        <button
          style={{ backgroundColor: currentColor }}
          className="text-white w-36 py-2 px-4 rounded-md text-sm"
          onClick={() => {
            setAddMemberData({
              selected_member: [],
              member_temp: null,
              member_list: [],
            });
            setToggleAddMember(true);
          }}
        >
          Add Members
        </button>
      </div>
      {toggleAddMember && (
        <div className="overflow-auto absolute z-[999999999999] top-0 left-0 flex justify-center w-full min-h-screen h-full overflow-y-auto py-40 px-[100px] bg-slate-800/50">
          <div className="bg-white flex flex-col gap-2 w-full max-w-[464px] h-fit rounded-xl p-8">
            <div className="flex items-center justify-between">
              <h1 className="text-xl font-medium">Add Members</h1>
              <div
                className="cursor-pointer p-2"
                onClick={() => setToggleAddMember(false)}
              >
                &times;
              </div>
            </div>
            <hr />
            <div className="flex flex-col gap-4 w-fit">
              <div className="flex flex-col gap-2">
                {addMemberData.selected_member.length > 0 && (
                  <div className="flex flex-col bg-white border border-slate-500 rounded-md">
                    {addMemberData.selected_member.map((item, index) => (
                      <div
                        key={"selectedMember" + index}
                        className="flex justify-between items-center py-3 px-4"
                      >
                        <div className="flex gap-2 items-center">
                          <div>
                            <img
                              src={
                                item.image
                                  ? "data:image/*;base64," + item.image
                                  : BlankProfile
                              }
                              alt="User profile image"
                              className="w-10 h-10 rounded-full object-cover"
                            />
                          </div>
                          <div className="fles flex-col justify-center text-sm">
                            <h1>{item.name}</h1>
                            <h3 className="text-slate-700 font-semibold">
                              {"@" + item.username}
                            </h3>
                          </div>
                        </div>
                        <button
                          className="p-2 cursor-pointer"
                          onClick={() => {
                            setAddMemberData((prev) => {
                              const newSelectedMembers = [
                                ...prev.selected_member,
                              ];
                              newSelectedMembers.splice(index, 1);

                              return {
                                ...prev,
                                selected_member: newSelectedMembers,
                              };
                            });
                          }}
                        >
                          <FaXmark className="w-3 h-3 text-slate-800" />
                        </button>
                      </div>
                    ))}
                  </div>
                )}
                <input
                  type="text"
                  placeholder="Search User"
                  spellCheck="false"
                  className={
                    "w-[400px] p-2 text-sm rounded-[4px] border focus:outline-2 " +
                    (!addMemberWarning
                      ? "border-slate-500 focus:outline-sky-500"
                      : "border-red-500 focus:outline-red-500")
                  }
                  value={addMemberData.member_temp}
                  onChange={(e) => {
                    setAddMemberData((prev) => ({
                      ...prev,
                      member_temp: e.target.value,
                    }));
                    setAddMemberWarning(null);
                  }}
                />
                {addMemberWarning && (
                  <p className="text-xs text-red-500">{addMemberWarning}</p>
                )}
                {addMemberData.member_list.length !== 0 && (
                  <div className="flex flex-col w-[400px] max-h-[192px] border border-slate-500 overflow-y-auto rounded-md cursor-pointer">
                    {addMemberData.member_list.map((item, index) => (
                      <div
                        key={"member" + index}
                        className="py-3 px-4 flex justify-between items-center bg-white hover:bg-slate-200 active:bg-slate-50"
                        onClick={() => {
                          if (
                            !addMemberData.selected_member.some(
                              (member) => member.uuid === item.uuid,
                            ) &&
                            !detailData.integrated_members.some(
                              (member) => member.user.uuid === item.uuid,
                            )
                          ) {
                            setAddMemberData((prev) => ({
                              ...prev,
                              selected_member: [...prev.selected_member, item],
                              member_temp: "",
                              member_list: [],
                            }));
                          }
                        }}
                      >
                        <div className="flex gap-2 items-center">
                          <div>
                            <img
                              src={
                                item.image
                                  ? "data:image/*;base64," + item.image
                                  : BlankProfile
                              }
                              alt="User profile image"
                              className="w-10 h-10 rounded-full object-cover"
                            />
                          </div>
                          <div className="fles flex-col justify-center text-sm">
                            <h1>{item.name}</h1>
                            <h3 className="text-slate-700 font-semibold">
                              {"@" + item.username}
                            </h3>
                          </div>
                        </div>
                        <div>
                          <FaPlus className="w-3 h-3 text-slate-800" />
                        </div>
                      </div>
                    ))}
                  </div>
                )}
              </div>
              <div className="flex justify-end items-center">
                <button
                  disabled={
                    addMemberLoading || addMemberData.selected_member.length < 1
                  }
                  style={{ backgroundColor: currentColor }}
                  className="text-white w-36 mt-4 py-2 px-4 rounded-md text-sm"
                  onClick={async () => {
                    if (addMemberData.selected_member.length < 1) return;

                    setAddMemberLoading(true);

                    const prabayarMethod = paymentMethod.filter(
                      (item) => item.key_payment_method == "prabayar",
                    )[0];

                    const currentMember = detailData.integrated_members.map(
                      (item) => item.user.uuid,
                    );

                    const newMember = addMemberData.selected_member.map(
                      (item) => item.uuid,
                    );

                    const allMember = currentMember
                      .concat(newMember)
                      ?.filter((member) => {
                        return member !== detailData.owner.uuid;
                      });

                    await axios
                      .put(
                        API_ROOT +
                          "/admin/user/integrated-platform/manage/update/" +
                          detailData.uuid,
                        {
                          members: allMember,
                        },
                        {
                          headers: {
                            Authorization: getCookie("admin_auth"),
                          },
                        },
                      )
                      .then(async () => {
                        setToggleAddMember(false);
                        toast.success("Members Updated!", {
                          onOpen: () => fetchDetails(uuid),
                        });
                      })
                      .catch((error) => {
                        toast.error("Failed to update members!");

                        if (error.response) {
                          if (error.response.status == 401) {
                            navigate("/login");
                          } else if (
                            error.response.data.err.type === "service"
                          ) {
                            if (error.response.data.err.data.code === -4) {
                              setAddMemberWarning("Owner cannot be member");
                            }
                          }
                        }
                      });

                    setAddMemberLoading(false);
                  }}
                >
                  {!addMemberLoading ? "Add" : "Loading..."}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
      <div className="overflow-x-auto">
        <div className="w-fit">
          <GridComponent
            dataSource={memberData}
            width="auto"
            allowPaging
            allowSorting
            allowTextWrap={true}
            pageSettings={{
              pageCount: 5,
              pageSizes: ["All", "10", "25", "50"],
            }}
            textWrapSettings={{ wrapMode: "Content" }}
            toolbar={["Search"]}
            queryCellInfo={queryCellInfo}
            dataBound={dataBound}
            ref={gridRef}
          >
            <ColumnsDirective>
              <ColumnDirective
                field="No"
                headerText="No"
                textAlign="Center"
                width={50}
              />
              <ColumnDirective
                field="Uuid"
                headerText="Action"
                textAlign="Center"
                isPrimaryKey={true}
                template={actionTemplate}
              />
              <ColumnDirective
                field="Name"
                headerText="Name"
                textAlign="Left"
              />
              <ColumnDirective
                field="Username"
                headerText="Username"
                textAlign="Left"
              />
              <ColumnDirective
                field="Email"
                headerText="Email"
                textAlign="Left"
              />
              <ColumnDirective
                field="PhoneNumber"
                headerText="Phone Number"
                textAlign="Left"
              />
              <ColumnDirective
                field="StatusMarkany"
                headerText="Status Markany"
                textAlign="Center"
                template={(props) => (
                  <span
                    className={`px-2 py-1 rounded-full text-xs font-medium ${getBadgeStatusMarkany(props.StatusMarkany).class}`}
                  >
                    {getBadgeStatusMarkany(props.StatusMarkany).label}
                  </span>
                )}
              />
              <ColumnDirective
                field="IsActive"
                headerText="Member Status"
                textAlign="Center"
                template={(props) => (
                  <span
                    className={`px-2 py-1 rounded-full text-xs font-medium ${
                      props.IsActive
                        ? "bg-green-100 text-green-800"
                        : "bg-red-100 text-red-800"
                    }`}
                  >
                    {props.IsActive ? "Active" : "Inactive"}
                  </span>
                )}
              />
              <ColumnDirective
                field="StatusEkyc"
                headerText="Status EKYC"
                textAlign="Center"
                template={(props) => (
                  <span
                    className={`px-2 py-1 rounded-full text-xs font-medium ${
                      props.Ekyc
                        ? "bg-green-100 text-green-800"
                        : "bg-red-100 text-red-800"
                    }`}
                  >
                    {props.Ekyc ? "Uploaded" : "Not Uploaded"}
                  </span>
                )}
              />
              <ColumnDirective
                field="LinkOnboardingExpired"
                headerText="Link Onboarding Expired"
                textAlign="Center"
                template={(props) =>
                  props.LinkOnboardingExpired
                    ? new Date(props.LinkOnboardingExpired).toLocaleString()
                    : "-"
                }
              />
              <ColumnDirective
                field="StatusCertificateCa"
                headerText="Status Certificate"
                textAlign="Center"
                template={(props) => (
                  <span
                    className={`px-2 py-1 rounded-full text-xs font-medium ${getBadgeStatusCertificate(props.StatusCertificateCa).class}`}
                  >
                    {getBadgeStatusCertificate(props.StatusCertificateCa).label}
                  </span>
                )}
              />
              <ColumnDirective
                field="PaymentMethod"
                headerText="Payment Method"
                textAlign="Center"
              />
              <ColumnDirective field="PaymentMethodKey" visible={false} />
            </ColumnsDirective>
            <Inject services={[Search, Toolbar, Page, Sort, Resize]} />
          </GridComponent>
        </div>
      </div>
      {editMember && (
        <div className="overflow-auto absolute z-[999999999999] top-0 left-0 flex justify-center w-full min-h-screen h-full py-40 px-[100px] bg-slate-800/50">
          <div className="flex flex-col gap-4 bg-white w-full max-w-[1000px] h-fit rounded-xl p-8">
            <div className="flex items-center justify-between">
              <h1 className="text-xl font-medium">Edit Member</h1>
              <div
                className="cursor-pointer p-2"
                onClick={() => {
                  setEditMember(null);
                }}
              >
                &times;
              </div>
            </div>
            <hr />
            <div className="flex flex-col gap-1">
              <div className="flex">
                <div className="flex-none w-40 bg-gray-600 text-white pl-2 py-1 flex items-center">
                  Name
                </div>
                <div className="flex-auto px-2 py-1 border border-gray-600 box-border break-all">
                  {editMember.Name}
                </div>
              </div>
              <div className="flex">
                <div className="flex-none w-40 bg-gray-600 text-white pl-2 py-1 flex items-center">
                  Username
                </div>
                <div className="flex-auto px-2 py-1 border border-gray-600 box-border break-all">
                  {editMember.Username}
                </div>
              </div>
              <div className="flex">
                <div className="flex-none w-40 bg-gray-600 text-white pl-2 py-1 flex items-center">
                  Email
                </div>
                <div className="flex-auto px-2 py-1 border border-gray-600 box-border break-all">
                  {editMember.Email}
                </div>
              </div>
              <div className="flex">
                <div className="flex-none w-40 bg-gray-600 text-white pl-2 py-1 flex items-center">
                  Phone Number
                </div>
                <div className="flex-auto px-2 py-1 border border-gray-600 box-border break-all">
                  {editMember.PhoneNumber}
                </div>
              </div>
              <div className="flex">
                <div className="flex-none w-40 bg-gray-600 text-white pl-2 py-1 flex items-center">
                  Member Status
                </div>
                <div className="flex-auto px-2 py-1 border border-gray-600 box-border break-all">
                  {editMember.IsActiveText}
                </div>
              </div>
              <div className="flex">
                <div className="flex-none w-40 bg-gray-600 text-white pl-2 py-1 flex items-center">
                  Payment Method
                </div>
                <div className="flex-auto px-2 py-1 border border-gray-600 box-border break-all">
                  {editMember.PaymentMethod}
                </div>
              </div>
              <div className="flex">
                <div className="flex-none w-40 bg-gray-600 text-white pl-2 py-1 flex items-center">
                  Status Markany
                </div>
                <div className="flex-auto px-2 py-1 border border-gray-600 box-border">
                  <select
                    disabled={editMemberLoading}
                    value={editMember.StatusMarkany || ""}
                    onChange={async (e) => {
                      setEditMember({
                        ...editMember,
                        StatusMarkany: e.target.value,
                      });
                      setEditMemberLoading(true);

                      const editedMembers = detailData.integrated_members.map(
                        (member) => {
                          if (member.user.uuid == editMember.Uuid) {
                            return {
                              status_markany: e.target.value,
                              user_uuid: member.user.uuid,
                              is_member: member.is_member,
                              payment_method_uuid: member.payment_method.uuid,
                            };
                          } else {
                            return {
                              status_markany:
                                member.user?.user_detail?.status_markany,
                              user_uuid: member.user.uuid,
                              is_member: member.is_member,
                              payment_method_uuid: member.payment_method.uuid,
                            };
                          }
                        },
                      );

                      await axios
                        .put(
                          API_ROOT +
                            "/admin/user/integrated-platform/manage/update/" +
                            detailData.uuid,
                          {
                            platform_name: null,
                            customer_key: null,
                            sumber_platform_id: null,
                            sumber_platform_id: null,
                            api_key: null,
                            issuerId: null,
                            is_active: null,
                            owner: null,
                            members: editedMembers,
                          },
                          {
                            headers: {
                              Authorization: getCookie("admin_auth"),
                            },
                          },
                        )
                        .then(async () => {
                          setEditMember(null);
                          toast.success("Member updated", {
                            onOpen: () => fetchDetails(uuid),
                          });
                        })
                        .catch((error) => {
                          toast.error("Failed to update member!");

                          if (error.response) {
                            if (error.response.status == 401) {
                              navigate("/login");
                            }
                          }
                        });

                      setEditMemberLoading(false);
                    }}
                    className="w-full outline-none"
                  >
                    <option value="">Select Status</option>
                    <option value="register-account">Register Account</option>
                    <option value="generate-link">Generate Link</option>
                    <option value="onboarding-peruri">Onboarding Peruri</option>
                    <option value="menunggu-verification-peruri">
                      Menunggu Verifikasi Peruri
                    </option>
                    <option value="completed">Completed</option>
                  </select>
                </div>
              </div>
            </div>
            <div className="flex justify-end items-stretch gap-4 mt-4">
              <button
                disabled={editMemberLoading}
                className="text-white w-44 py-2 px-4 rounded-md text-sm bg-sky-500 hoveer:bg-sky-600"
                onClick={async () => {
                  setEditMemberLoading(true);

                  const prabayarMethod = paymentMethod.filter(
                    (item) => item.key_payment_method == "prabayar",
                  )[0];
                  const pascabayarMethod = paymentMethod.filter(
                    (item) => item.key_payment_method == "pascabayar",
                  )[0];

                  const editedMembers = detailData.integrated_members.map(
                    (member) => {
                      if (member.user.uuid == editMember.Uuid) {
                        if (
                          member.payment_method.key_payment_method ==
                          prabayarMethod.key_payment_method
                        ) {
                          return {
                            status_markany:
                              member.user?.user_detail?.status_markany,
                            user_uuid: member.user.uuid,
                            is_member: member.is_member,
                            payment_method_uuid: pascabayarMethod.uuid,
                          };
                        } else {
                          return {
                            status_markany:
                              member.user?.user_detail?.status_markany,
                            user_uuid: member.user.uuid,
                            is_member: member.is_member,
                            payment_method_uuid: prabayarMethod.uuid,
                          };
                        }
                      } else {
                        return {
                          status_markany:
                            member.user?.user_detail?.status_markany,
                          user_uuid: member.user.uuid,
                          is_member: member.is_member,
                          payment_method_uuid: member.payment_method.uuid,
                        };
                      }
                    },
                  );

                  await axios
                    .put(
                      API_ROOT +
                        "/admin/user/integrated-platform/manage/update/" +
                        detailData.uuid,
                      {
                        platform_name: null,
                        customer_key: null,
                        sumber_platform_id: null,
                        sumber_platform_id: null,
                        sumber_platform_id: null,
                        api_key: null,
                        issuerId: null,
                        is_active: null,
                        owner: null,
                        members: editedMembers,
                      },
                      {
                        headers: {
                          Authorization: getCookie("admin_auth"),
                        },
                      },
                    )
                    .then(async () => {
                      setEditMember(null);
                      toast.success("Member method updated!", {
                        onOpen: () => fetchDetails(uuid),
                      });
                    })
                    .catch((error) => {
                      toast.error("Failed to update method!");

                      if (error.response) {
                        if (error.response.status == 401) {
                          navigate("/login");
                        }
                      }
                    });

                  setEditMemberLoading(false);
                }}
              >
                {editMemberLoading
                  ? "Loading..."
                  : editMember.PaymentMethodKey === "prabayar"
                    ? "Change Method to Pascabayar"
                    : "Change Method to Prabayar"}
              </button>
              <button
                disabled={editMemberLoading}
                className={
                  "text-white w-44 py-2 px-4 rounded-md text-sm " +
                  (editMember.IsActive
                    ? "bg-amber-500 hover:bg-amber-600"
                    : "bg-green-500 hover:bg-green-600")
                }
                onClick={async () => {
                  setEditMemberLoading(true);

                  const editedMembers = detailData.integrated_members.map(
                    (member) => {
                      if (member.user.uuid == editMember.Uuid) {
                        return {
                          status_markany:
                            member.user?.user_detail?.status_markany,
                          user_uuid: member.user.uuid,
                          is_member: !member.is_member,
                          payment_method_uuid: member.payment_method.uuid,
                        };
                      } else {
                        return {
                          status_markany:
                            member.user?.user_detail?.status_markany,
                          user_uuid: member.user.uuid,
                          is_member: member.is_member,
                          payment_method_uuid: member.payment_method.uuid,
                        };
                      }
                    },
                  );

                  await axios
                    .put(
                      API_ROOT +
                        "/admin/user/integrated-platform/manage/update/" +
                        detailData.uuid,
                      {
                        platform_name: null,
                        customer_key: null,
                        sumber_platform_id: null,
                        sumber_platform_id: null,
                        api_key: null,
                        issuerId: null,
                        is_active: null,
                        owner: null,
                        members: editedMembers,
                      },
                      {
                        headers: {
                          Authorization: getCookie("admin_auth"),
                        },
                      },
                    )
                    .then(async () => {
                      setEditMember(null);
                      toast.success(
                        detailData.is_active
                          ? "Member Deactivated!"
                          : "Member Activated",
                        {
                          onOpen: () => fetchDetails(uuid),
                        },
                      );
                    })
                    .catch((error) => {
                      toast.error("Failed to update member!");

                      if (error.response) {
                        if (error.response.status == 401) {
                          navigate("/login");
                        }
                      }
                    });

                  setEditMemberLoading(false);
                }}
              >
                {editMemberLoading
                  ? "Loading..."
                  : editMember.IsActive
                    ? "Deactivate Member"
                    : "Activate Member"}
              </button>
              <button
                disabled={editMemberLoading}
                className="text-white w-40 py-2 px-4 rounded-md text-sm bg-red-500 hover:bg-red-600"
                onClick={() => setDeleteMemberValidation(true)}
              >
                {editMemberLoading ? "Loading..." : "Remove Member"}
              </button>
              {deleteMemberValidation && (
                <DeleteValidation
                  title={
                    <div className="text-center">
                      <p>{editMember.Name}</p>
                      <p>Are you sure want to remove this member?</p>
                    </div>
                  }
                  falseHandler={() => setDeleteMemberValidation(false)}
                  trueHandler={async () => {
                    setEditMemberLoading(true);

                    const restMember = detailData.integrated_members.filter(
                      (member) => member.user.uuid !== editMember.Uuid,
                    );

                    const restData = restMember.map((member) => ({
                      status_markany: member.user?.user_detail?.status_markany,
                      user_uuid: member.user.uuid,
                      is_member: member.is_member,
                      payment_method_uuid: member.payment_method.uuid,
                    }));

                    await axios
                      .put(
                        API_ROOT +
                          "/admin/user/integrated-platform/manage/update/" +
                          detailData.uuid,
                        {
                          platform_name: null,
                          customer_key: null,
                          sumber_platform_id: null,
                          api_key: null,
                          issuerId: null,
                          owner: null,
                          is_active: null,
                          members: restData,
                        },
                        {
                          headers: {
                            Authorization: getCookie("admin_auth"),
                          },
                        },
                      )
                      .then(async () => {
                        setEditMember(null);
                        toast.success("Members deleted!", {
                          onOpen: () => fetchDetails(uuid),
                        });
                      })
                      .catch((error) => {
                        toast.error("Failed to delete members!");

                        if (error.response) {
                          if (error.response.status == 401) {
                            navigate("/login");
                          }
                        }
                      });

                    setEditMemberLoading(false);
                    setDeleteMemberValidation(false);
                  }}
                />
              )}
            </div>
          </div>
        </div>
      )}

      {/* Register Loading Modal */}
      {(registerLoading ||
        sendEkycLoading ||
        signupPdsLoading ||
        certificateCheckLoading) && (
        <div className="overflow-auto absolute z-[99] top-0 left-0 flex justify-center items-center w-full min-h-screen h-full overflow-y-auto py-10 px-4 bg-slate-800/50">
          <div className="bg-white flex flex-col gap-2 w-full max-w-4xl h-fit rounded-xl p-8">
            <div>
              {registerLoading
                ? "Registering User to Markany. Please wait..."
                : sendEkycLoading
                  ? "Send eKYC User to Markany. Please wait..."
                  : signupPdsLoading
                    ? "Signup PDS User to Markany. Please wait..."
                    : certificateCheckLoading
                      ? "Certificate check user to Markany. Please wait..."
                      : "Please wait..."}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Details;
